import { CLEAR_SALESPERSON } from "../action";

export function clearSalesPersonDetails() {
  return (dispatch) => {
    dispatch({ type: CLEAR_SALESPERSON });
  };
}
